module.exports = __webpack_public_path__ + "static/img/icon-kakaostory.c11c782b.png";